<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
<div [hidden]="isLoading">
  <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
    <ziro-pin-reset
      #vmPin
      [hidden]="!isVmPresent"
      [fieldId]="'voicemailPinReset'"
      (resetClicked)="onSubmit($event)"
    ></ziro-pin-reset>
    <ziro-pin-reset
      #emPin
      [hidden]="!isEmPresent"
      [fieldId]="'extensionMobPinReset'"
      (resetClicked)="onSubmit($event)"
    ></ziro-pin-reset>
  </ziro-collapsible-section-card>
</div>
